import { useTranslation } from 'next-i18next';

// Note: Google OAuth 심사에 통과하려면 서비스를 host하는 도메인의 하위에 terms, policy 페이지가 있어야 해서 추가합니다.
export function PrivacyPolicyPage() {
  const {
    t
  } = useTranslation('common');
  return <div className="size-full" data-sentry-component="PrivacyPolicyPage" data-sentry-source-file="PrivacyPolicyPage.tsx">
      <iframe className="h-screen w-full" src={t('common.account.privacyUrl')} />
    </div>;
}